export enum AutopilotStateEnum {
    None,
    Preflight,
    Manual,
    Stabilized,
    Guided,
    Auto,
    Terminate,
    Emergency
}